import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const PrivacyPolicy = () => {
  return (
    <div
      style={{ paddingBottom: "150px", background: "#000", paddingTop: "50px" }}
    >
      <div className="how_to" style={{ paddingTop: "100px" }}>
        <Container>
          <Row className="row sk__featureboxes">
            <Col className="col text-center sk__heading-spacer-s">
              <div className="cover-text-wrapper" style={{ zIndex: 10 }}>
                <div
                  className="fancy-gradient-text-box"
                  style={{ transform: "translate(0px, 0px)", opacity: 1 }}
                >
                  <h1 className="super-heading sk__gradient-fancy-text mb-2 mb-sm-0 mb-xxl-2 make_small_mobile">
                    Privacy Policy
                  </h1>
                  <span className="super-heading sk__gradient-fancy-text-back mb-2 mb-sm-0 mb-xxl-2 make_small_mobile">
                    {" "}
                    Privacy Policy
                  </span>
                </div>
              </div>
              <h2
                className="h2 sk__fade-in-6"
                data-sk-fade-match={3}
                style={{ opacity: 1 }}
              >
                {/* This Privacy Policy explains how FTtunes collects, stores and uses any personal data we gather from you. Our commitment is to manage your data in accordance with the data protection laws of the UK and EU, ensuring your privacy is protected to the best of our abilities. */}
              </h2>
            </Col>
          </Row>

          <Row
            className="justify-content-center"
            style={{ color: "#fff", lineHeight: "30px" }}
          >
            <Col lg={8}>
              <article className="text-justify">
                <ol>
                  <li>
                    <strong>Our Commitment to Data Protection</strong>
                    <ul>
                      {/* <li>
                        This policy explains how FTtunes collects, stores, and
                        uses any personal data collected.
                      </li> */}
                      <li>At FTtunes, we are committed to:</li>
                      <li>
                        Following all applicable data protection laws and
                        regulations.
                        <ul>
                          {/* <li>Abide by all current data protection laws.</li> */}
                          <li>
                            Notifying relevant parties within 72 hours of any
                            data breach that becomes known to us.
                          </li>
                          <li>
                            Collecting only the necessary data required to carry
                            out our business and fulfill the needs of our
                            clients.
                          </li>
                        </ul>
                        <div style={{ position: "relative" }}>
                          <img
                            src="data:image/jpeg;base64,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"
                            alt="VRE"
                            class=" blur-1"
                            style={{
                              position: "absolute",
                              top: "0px",
                              left: "50%",
                              transform: "translateX(-50%)",
                            }}
                          ></img>
                        </div>
                      </li>
                      <li>
                        Please note that this policy is intended to cover the
                        rights of individuals and pertains to personal data that
                        we process. The rights of companies and other
                        non-individual entities, as well as data not classified
                        as personal under current law, may differ.
                      </li>
                      <li>
                        In many cases, FTtunes operates as a data processor on
                        behalf of its clients, who are the data controllers. As
                        a result, many of the legal rights and obligations
                        relating to your personal data may ultimately lie with
                        these third-party data controllers.
                      </li>
                    </ul>
                  </li>
                  <li>
                    <strong>Who We Are</strong>
                    <br />
                    Organisation: FTtunes
                    <br />
                    Contact No: +91 7492047656
                    <br />
                    Registered Office: India-Head Office
                    <br />
                    A2, 2nd Floor,
                    <br />
                    Palam Dabri Road,
                    <br />
                    Mahavir Enclave Dwarka, New Delhi - 110045
                    <br />
                    Throughout this document, "we," "us," and "FTtunes" refer to
                    FTtunes, the company.
                  </li>
                  <li>
                    <strong>What Information We Collect</strong>
                    <ul>
                      <li>
                        As a music distribution company, we need certain
                        information from you to provide our services
                        effectively. The personal information we gather may
                        include, but is not limited to the following:
                        <ul>
                          <li>
                            Your email address when you subscribe to our blog;
                          </li>
                          <li>
                            Your first and last name, email address and mailing
                            address when creating an account.
                          </li>
                          <li>
                            Payment information provided when you subscribe to
                            our services.
                          </li>
                          <li>
                            Your language preference, subscription plan, billing
                            information and promotional code, where applicable.
                          </li>
                          <li>
                            - Files, content, configuration parameters and other
                            information you provide, such as photos, audio files
                            and production preferences.
                          </li>
                          <li>Your contact list, if you grant us access.</li>
                          <li>Your visitor profile on our website and blog.</li>
                          <li>
                            Your interactions with us, including emails and
                            social media engagements.
                          </li>
                          <li>Your bank details for payments to you.</li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <strong>Legal Basis for Collecting Data</strong>
                    <ul>
                      <li>
                        Once we collect your data, the following legal grounds
                        apply:
                      </li>
                      <li>
                        Consent: We will ask for your explicit consent to use
                        your data and will explain how it will be used, such as
                        for promotional communications or newsletters.
                      </li>
                      <li>
                        Contractual Obligations: We may use your data to fulfill
                        a business relationship or contract with you, such as
                        processing payments.
                      </li>
                      <li>
                        Legal Compliance: We may collect and share certain
                        information to meet legal requirements, such as tax
                        residency information.
                      </li>
                      <li>
                        Legitimate Interest: In some cases, we collect data in
                        ways that are reasonably expected as part of running our
                        business, without significantly impacting your rights,
                        freedoms or interests. For example, we may store your IP
                        address to prevent fraud.
                      </li>
                    </ul>
                  </li>

                  <li>
                    <strong>Security Measures</strong>
                    <ul>
                      <li>
                        Protecting your data is our highest priority. Here are
                        some of the measures we implement to ensure its
                        security:
                        <ul>
                          <li>
                            SSL encryption is used to secure all client systems.
                          </li>
                          <li>
                            Sensitive data, such as passwords and payment
                            details, are encrypted before storage on FTtunes
                            servers.
                          </li>
                          <li>
                            We will not share your data with third parties
                            without your prior written consent, unless required
                            by law or necessary to perform business activities
                            as agreed upon with you.
                          </li>
                          <div style={{ position: "relative" }}>
                            <img
                              src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBwgHBgkIBwgKCgkLDRYPDQwMDRsUFRAWIB0iIiAdHx8kKDQsJCYxJx8fLT0tMTU3Ojo6Iys/RD84QzQ5OjcBCgoKDQwNGg8PGjclHyU3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3N//AABEIAKwAtwMBIgACEQEDEQH/xAAbAAADAQEBAQEAAAAAAAAAAAAAAgMBBAYFB//EAB4QAQEBAQEBAAIDAAAAAAAAAAACARESAxNxBDFR/8QAGwEAAwEBAQEBAAAAAAAAAAAAAQIDAAUEBwb/xAAaEQEBAQEBAQEAAAAAAAAAAAAAAQIREhMD/9oADAMBAAIRAxEAPwD89yT5J8k2S+iTD9BMEyW5J+N4pMnmS8HD8bwfJvJODh+Dg+R4Xg4bjeDxuE4OH4ONxuE43huDg8bhW8NxvB4PGcHDcHDcNxnG8bw2T6/oeDwnBxafjVK5/G/YdkC2OXgdmfxpAe8h6j5mYbhuAsyHGcHG8bweDxnA0cHgsBuDg8bhQbgbjcKOGDcbjOBvG8HjcZwcMODweAZPf6PHz2v06fn8i3UgXUiXz+P+umPkpHzXiEdfojraM/JWfkvMKT80btK7c+fJjsz5gn0J7eV4DcHHQ46HGBoHjMDQ3GYG8HGbjA3g4zcYGt4zcZwGyKVj4hbIFsiMztL/AD+SsfNeIT1tPW04+a8QeYWmENbR1osQrMGiFohHWkroswrMHmFZhG6Tuk8gOmYBPROvEb86Ls679+adfN15t1Jtxt46fxjPmPsfbm863xrqyG+G9h7cufOm/idXhvgPYe3J+Jv4nV4HgPbe3NnyNPzdGQbIC7C7Sn5qzB8hSYTuk7okwrEHmFZhPWk7osyrMGmFphHWkrSzC0QaIWmEdaTtJMKzB5hWYSuiWkmAvMhP0TryOwnsO2oSqHVmnQmnLsM8OjYZ4N6N6R8jyt5bkt6b0j5b5W8jyHoPSPlvlbyPLeg9JeTZCmSbJC6C6TyFJk+SpMkui2kmVphsytMpa0naWIWiGzK8QlrSdpYhaINELRCGtJ2lmFZg8wpMpXRbU8gOjIBPRevJ1CVQ7ahKodOaeyVybBfLpqCbKk0eaQ8t8q+R5H03pLy3yp5b5brdS8t8qeW5IdbqeSfJPkmyQui2kmVJg8ypMp3RbSzKsS2YWiE7olrIheJEytEo60naIlaJEStMoa0S1kyrMtmVZlK6LaTJC+SCei9eWuEah31CNw6WdPVK4qkmy6qhOpVmjyufyzytss8n6PU/I8qcHG63U/Jsk/luSHW6TJPknzDZJbS2syVJlsyrMp3RbWTK0y2ZViUtaJaJhaZEytMo60S0RK0yIlaZR1olpZlSZNMqZKV0XpckKZgL0HnqhG4d1QjcPfnS8rhqEqh2XCVStnR5XJsl8umpJsqTR+o8HFPI8j1ukzG5J8k2SFrdJkqTJplSZLdFtLMqzLZlWZSuiWiZVmWzKsylrRbRMrTImVplHWiWiJVmRMqziNpGZJ8xuSfJTtAuSFMwB1uvjVCNw7qlG4evOlJXBcI1DuuEahbOjyuOpT2XVUp1K00eVz+WeVtlnDdHqeSbJPkmyQtbpclSZbkqTJLS2smVpkTKsyndFtESvMliV5lHVJaJlWZEyrMo2lE4pMtmT5idpRmGyTZhsxO0C8B+AOs+dUo3Ds2Uql6JoziuELl3XKFwtnR5XFUpVLrqEqlaaPK5dlnF9kvlSaHqWYfJNkmyWtbrJlSZbMqTKdodEytMsmVplK0lomVplkyrMpapa2cVmWTKsylaUTKmYMw+YlaDMw2Y3MNmFtAvAbgDrOTZTuXRqdYrKPXLUo3LqrEqxXOjOOoRuXZeI3i+dGlctSTZXrCbik0fqfk2Ybjcwet0TKs4ycVnE7S2tmVZlkqylqlpplWZZKspWlbOKZgk+JWgMw+YMNhLSjMbmGxpesTgMGZ//9k="
                              alt="VRE"
                              class=" blur-1"
                              style={{
                                position: "absolute",
                                top: "0px",
                                left: "50%",
                                transform: "translateX(-50%)",
                              }}
                            ></img>
                          </div>
                          <li>
                            Data access is restricted to authorized personnel
                            only, typically managed through username and
                            password protection.
                          </li>
                          <li>
                            All data used within FTtunes systems is stored on
                            servers operated by companies that comply with
                            current data protection laws.
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>

                  <li>
                    <strong>Your Rights</strong>
                    <ul>
                      <li>
                        As an individual, you have the following rights
                        regarding your personal data:
                        <ul>
                          <li>
                            Access: You can request access to the personal data
                            we hold about you, usually free of charge.
                          </li>
                          <li>
                            Correction: You can ask us to correct any
                            inaccuracies or update incomplete information.
                          </li>
                          <li>
                            Direct Marketing: You have the right to ask us to
                            stop using your data for direct marketing
                            activities.
                          </li>
                          <li>
                            Consent Withdrawal: You can withdraw your consent
                            for processing your data and we will cease any
                            consent-based processing.
                          </li>
                        </ul>
                      </li>
                      <li>
                        In many cases, FTtunes acts as a data processor on
                        behalf of our clients, who are the data controllers.
                        While we strive to facilitate access to, correction of,
                        or deletion of your data, the ultimate legal
                        responsibility may rest with the data controller.
                      </li>
                      <li>
                        Please note that even after unsubscribing from certain
                        services, we may retain your details to maintain records
                        of past interactions where we have a legitimate interest
                        in doing so.
                      </li>
                      {/* <li>
                        Note that even after unsubscribing from some services,
                        we may keep your details on record to allow us to recall
                        past relationships where there is a legitimate interest
                        to do so.
                      </li> */}
                    </ul>
                  </li>
                  <li>
                    <strong>Contact Us</strong>
                    <ul>
                      <li>
                        If you have any questions or concerns about how we
                        manage your data, please do not hesitate to contact us.
                      </li>
                    </ul>
                  </li>
                </ol>
              </article>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
